export const mapRange = (value, source, target) => target[0] + (value - source[0]) * (target[1] - target[0]) / (source[1] - source[0]);
export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
